module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-mitsu.1e1ac941.png";